'use strict';

var DocsController = function ($scope, DocsLinksService) {
    var vm = this;
    vm.docLinks = DocsLinksService;
};

DocsController.$inject = [ '$scope', 'DocsLinksService' ];
export default DocsController;
